import React from "react";

import { FlattenedPlanData } from "../../../hooks/useWellnessPlans";

interface IWellnessPlanDetailsHeader {
  planData: FlattenedPlanData;
  petName: string;
}

const WellnessPlanDetailsHeader = ({
  planData,
}: IWellnessPlanDetailsHeader) => {
  return (
    <div className="flex flex-col items-center gap-1 px-4 py-4 rounded-t-xl bg-violet-9 border-b border-violet-6">
      <div className="text-lg font-semibold text-center">
        {planData.planName}
      </div>
      <div className="text-sm text-center text-light-black">
        {planData.description}
      </div>
    </div>
  );
};

export default WellnessPlanDetailsHeader;
